export default __webpack_public_path__ + "static/media/wallet-fill.e58b879d.svg";